export enum AttendanceTypeEnum {
    Join = 1,
    Leave = 2,
}